import type { Doc } from "building-types/doc";
import type { RoomLayoutEntityHandle } from "building-types/roomLayouts/roomLayoutTypes";
import { assertIsNotUndefined } from "common/utils/assertOfType";
import { docGetTableEntity } from "../../entity/docGetTableEntity";
import { getDocEntityIdFromGeneratedRoomLayoutEligibleEntity } from "./roomLayoutTools";

export function docGetGeneratedRoomLayoutEligibleHandles(doc: Doc, handles: RoomLayoutEntityHandle[]) {
  const roomLayoutHandles: RoomLayoutEntityHandle[] = [];

  for (const handle of handles) {
    const roomLayoutEntity = docGetTableEntity(doc, handle);

    if (!roomLayoutEntity) {
      continue;
    }

    const roomLayoutEntityId = getDocEntityIdFromGeneratedRoomLayoutEligibleEntity(roomLayoutEntity);
    assertIsNotUndefined(roomLayoutEntityId);

    roomLayoutHandles.push({ type: handle.type, id: roomLayoutEntityId });
  }

  return roomLayoutHandles;
}
